"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubFormLinkService = void 0;
var core_api_1 = require("@ikegps/core-api");
var core_shared_1 = require("@ikegps/core-shared");
var core_shared_2 = require("@ikegps/core-shared");
var field_transform_1 = require("./field.transform");
var LINK_SUBFORM_INSTANCE = true;
var SubFormLinkService = /** @class */ (function () {
    function SubFormLinkService() {
        this.__priority = 100;
    }
    SubFormLinkService.prototype.isSubFormCompatible = function (form) {
        return this.getRules(form) != null;
    };
    SubFormLinkService.prototype.findLinks = function (collection, candidateCollections) {
        var subFormLinks = [];
        var location = collection.location;
        var fields = collection.schema.fields.slice();
        while (fields.length > 0) {
            var fieldSchema = fields.pop();
            if (fieldSchema.type !== core_api_1.IkeFieldType.FORM) {
                continue;
            }
            var subform = collection.getField(fieldSchema.id);
            var rules = this.getRules(subform.schema);
            if (rules == null) {
                fields.push.apply(fields, subform.value);
                continue;
            }
            for (var _i = 0, candidateCollections_1 = candidateCollections; _i < candidateCollections_1.length; _i++) {
                var candidateCollection = candidateCollections_1[_i];
                var subFormLink = this.getLink(rules, subform, location, candidateCollection);
                if (subFormLink != null) {
                    subFormLinks.push(subFormLink);
                }
            }
        }
        return subFormLinks;
    };
    SubFormLinkService.prototype.copySubForm = function (collection, subFormLinkRecord) {
        var instance = subFormLinkRecord.instance;
        var targetSubForm = collection.getField(instance.schema.id);
        var targetSubFormInstance = targetSubForm.Mutator.copyInstance(instance.parent, instance.instanceId, LINK_SUBFORM_INSTANCE);
        var rules = this.getRules(targetSubFormInstance.schema);
        targetSubFormInstance.forEachField(function (field) {
            var transform = field_transform_1.FieldTransform.create(field, rules.fields[field.schema.id]);
            if (transform == null) {
                return;
            }
            transform.apply(field);
        });
        // Remove measurements which link to external captures
        var externalCaptureIds = this.getCaptureIds(subFormLinkRecord.collection, targetSubFormInstance);
        targetSubFormInstance.forEachField(function (field) {
            if (!core_shared_2.CollectionModelFieldHeight.isHeightField(field) || !field.isPhotoMeasure()) {
                return;
            }
            var stateValue = field.stateValue;
            var drawableState = collection.getDrawableState(stateValue.captureId);
            var drawable = drawableState.getDrawable(stateValue.drawable);
            if (externalCaptureIds[drawable.captureId]) {
                field.Mutator.unlink();
            }
        });
        return targetSubFormInstance;
    };
    SubFormLinkService.prototype.getLink = function (rules, subform, location, candidateCollection) {
        var candidateSubForm = candidateCollection.getField(subform.schema.id);
        if (candidateSubForm == null || !candidateSubForm.hasValue()) {
            return null;
        }
        var candidateLocation = candidateCollection.location;
        var subFormLinks = [];
        for (var _i = 0, _a = candidateSubForm.value; _i < _a.length; _i++) {
            var candidateInstance = _a[_i];
            if (subform.getInstance(candidateInstance.instanceId) != null) {
                continue;
            }
            // Check if any rules reject any field in the candidate instance
            if (!this.matchesRules(rules, candidateInstance)) {
                continue;
            }
            var vectorField = candidateInstance.getField(rules.vector);
            var distance = this.getDistance(candidateLocation, vectorField, location);
            if (distance == null || distance >= rules.distance) {
                continue;
            }
            subFormLinks.push({
                collection: candidateCollection,
                instance: candidateInstance,
                distance: distance
            });
        }
        subFormLinks.sort(this.sortSubFormLinkRecords);
        return subFormLinks[0];
    };
    SubFormLinkService.prototype.matchesRules = function (rules, instance) {
        return instance.forEachField(function (field) {
            var transform = field_transform_1.FieldTransform.create(field, rules.fields[field.schema.id]);
            if (transform == null) {
                return true;
            }
            return transform.match(field);
        });
    };
    SubFormLinkService.prototype.getDistance = function (sourceLocation, sourceVectorField, targetLocation) {
        var spanLocation1 = null;
        var spanLocation2 = null;
        if (sourceVectorField.provider === core_shared_2.CollectionModelFieldVector.PROVIDER_P2P) {
            var captures = sourceVectorField.getCaptures();
            spanLocation1 = captures[0].target;
            spanLocation2 = captures[1].target;
        }
        else if (sourceVectorField.provider === core_shared_2.CollectionModelFieldVector.PROVIDER_MANUAL || sourceVectorField.provider === core_shared_2.CollectionModelFieldVector.PROVIDER_COLLECTION) {
            spanLocation1 = core_shared_1.IkeGeodesic.projectLocation(sourceLocation, sourceVectorField.value.bearing, sourceVectorField.value.distance);
            spanLocation2 = sourceLocation != null ? sourceLocation : spanLocation1;
        }
        else {
            return null;
        }
        var distance1 = core_shared_1.IkeGeodesic.getDistance(targetLocation, spanLocation1);
        var distance2 = core_shared_1.IkeGeodesic.getDistance(targetLocation, spanLocation2);
        return Math.min(distance1, distance2);
    };
    SubFormLinkService.prototype.getCaptureIds = function (collection, subformInstance) {
        var captureIds = {};
        collection.forEachField(function (field) {
            if (core_shared_1.CaptureProvider.isCaptureProvider(field)) {
                for (var _i = 0, _a = field.getCaptures(); _i < _a.length; _i++) {
                    var capture = _a[_i];
                    captureIds[capture.objectId] = true;
                }
            }
        });
        subformInstance.forEachField(function (field) {
            if (core_shared_1.CaptureProvider.isCaptureProvider(field)) {
                for (var _i = 0, _a = field.getCaptures(); _i < _a.length; _i++) {
                    var capture = _a[_i];
                    delete captureIds[capture.objectId];
                }
            }
        });
        return captureIds;
    };
    SubFormLinkService.prototype.sortSubFormLinkRecords = function (record1, record2) {
        return record1.distance - record2.distance;
    };
    SubFormLinkService.prototype.getRules = function (form) {
        for (var _i = 0, _a = form.providers; _i < _a.length; _i++) {
            var provider = _a[_i];
            if (provider == null) {
                continue;
            }
            if (typeof provider === 'object') {
                if (provider.type === core_api_1.IkeProviderType.EXISTING_SPAN) {
                    return provider;
                }
            }
            else if (provider === core_api_1.IkeProviderType.EXISTING_SPAN) {
                return core_shared_2.IkeCalcExistingSpanLegacyProvider;
            }
        }
        return null;
    };
    return SubFormLinkService;
}());
exports.SubFormLinkService = SubFormLinkService;
//# sourceMappingURL=subform.link.service.js.map